export enum EInternalUserType {
	'INTERNAL_WITH_WHITELIST' = 1,
	'INTERNAL_WITH_RESTRICTION' = 2
}

export const INTERNAL_USER_TYPE_OPTIONS = [
	{ id: 'INTERNAL_WITH_WHITELIST', label: 'INTERNAL_WITH_WHITELIST' },
	{ id: 'INTERNAL_WITH_RESTRICTION', label: 'INTERNAL_WITH_RESTRICTION' }
];

export const INTERNAL_USER_TYPE_OPTIONS_MAP = {
	[EInternalUserType.INTERNAL_WITH_WHITELIST]: 'INTERNAL_WITH_WHITELIST',
	[EInternalUserType.INTERNAL_WITH_RESTRICTION]: 'INTERNAL_WITH_RESTRICTION'
};

export enum EInternalEntityType {
	PHONE = 'PHONE',
	EMAIL = 'EMAIL'
}

export const INTERNAL_ENTITY_TYPE_OPTIONS = [
	{ id: 'PHONE', label: 'PHONE' },
	{ id: 'EMAIL', label: 'EMAIL' }
];

export enum EInternalUserURL {
	ADD_INTERNAL_USER = '/dashboard/addInternalUser/dashboard-internalUser-addInternalUser',
	UPDATE_INTERNAL_USER = '/dashboard/updateInternalUser/dashboard-internalUser-updateInternalUser',
	GET_INTERNAL_USER_LIST = '/dashboard/getInternalUserList/dashboard-internalUser-getInternalUserList'
}

export const EIntenalUserMangerList = [
	'Dilsher Singh Malhi',
	'Abhishek Gupta',
	'Karan Aggarwal',
	'Ankit Maheshwari',
	'Bijay Kumar Singh',
	'G.T. Thomas Phillippe',
	'Govind Mittal',
	'Katha Tara',
	'Mushyam Sairam',
	'Naveen Kadyan',
	'Nishant Jaiswal',
	'Sumit Yadav',
	'Sushil Patel',
	'Ishank Mehta',
	'Akshay Gulati'
];
